module.exports = __webpack_public_path__ + "img/success_icon.13a09463.svg";